import DownIcon from '@mui/icons-material/ArrowDownward';
import UpIcon from '@mui/icons-material/ArrowUpward';
import {
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {SORT_OPTIONS} from '../constants/index.js';

const COLUMN_LABELS = {
  date: 'Date',
  count: 'Count',
};

export const SortPicker = ({disabled, value, onChange}) => {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const icon = value.desc ? <UpIcon /> : <DownIcon />;

  const label = `Sorted by ${COLUMN_LABELS[value.column]}`;

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <IconButton
        disabled={disabled}
        variant="text"
        title={label}
        onClick={evt => {
          setMenuAnchor(evt.target);
        }}
        size="large"
      >
        {icon}
      </IconButton>
      <Menu
        anchorEl={menuAnchor}
        open={menuAnchor !== null}
        onClose={() => setMenuAnchor(null)}
      >
        {SORT_OPTIONS.map(option => (
          <MenuItem
            key={`${option.column}-${option.desc}`}
            onClick={() => {
              onChange(option);
              setMenuAnchor(null);
            }}
          >
            <ListItemIcon>
              {option.desc ? <UpIcon /> : <DownIcon />}
            </ListItemIcon>
            <Typography variant="inherit">
              {COLUMN_LABELS[option.column]}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

SortPicker.defaultProps = {
  value: {column: 'date', desc: false},
  onChange: () => {},
  disabled: false,
};

SortPicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
